import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

export enum ExperiencesDisplayMode {
  All = 'all',
  Custom = 'custom',
  ByLocation = 'byLocation',
}

export enum ExperienceSortOrder {
  Alphabetically = 'alphabetically',
  Manually = 'manually',
}

export enum ExperienceStatusFilter {
  UpcomingAndPast = 'upcomingAndPast',
  Upcoming = 'upcoming',
  Past = 'past',
}

export interface ExperiencesFilterConfig {
  displayMode: ExperiencesDisplayMode
  sortOrder: ExperienceSortOrder
  statusFilter: ExperienceStatusFilter
  enabledLocationIds?: string[]
  enabledExperienceIds?: string[]
  manualOrder?: string[]
}

interface LegacyFilterConfig {
  showAllLocations?: boolean
  enabledLocationIds?: string[]
  showAllExperiences?: boolean
  enabledExperienceIds?: string[]
}

const DEFAULT_FILTER_CONFIG: ExperiencesFilterConfig = {
  displayMode: ExperiencesDisplayMode.All,
  sortOrder: ExperienceSortOrder.Alphabetically,
  statusFilter: ExperienceStatusFilter.UpcomingAndPast,
}

export type ExperiencesSettingsParams = {
  experiencesFilterConfig: SettingsParamType.String
}

export const experiencesSettingsParams = createSettingsParams<ExperiencesSettingsParams>({
  experiencesFilterConfig: {
    type: SettingsParamType.String,
    getDefaultValue: () => JSON.stringify(DEFAULT_FILTER_CONFIG),
  },
})

const migrateLegacyConfig = (legacy: LegacyFilterConfig): ExperiencesFilterConfig => {
  let displayMode = ExperiencesDisplayMode.All

  if (legacy.showAllExperiences === false) {
    displayMode = ExperiencesDisplayMode.Custom
  } else if (legacy.showAllLocations === false) {
    displayMode = ExperiencesDisplayMode.ByLocation
  }

  return {
    displayMode,
    sortOrder: ExperienceSortOrder.Alphabetically,
    statusFilter: ExperienceStatusFilter.UpcomingAndPast,
    enabledLocationIds: legacy.enabledLocationIds,
    enabledExperienceIds: legacy.enabledExperienceIds,
  }
}

const isLegacyConfig = (config: any): config is LegacyFilterConfig =>
  'showAllLocations' in config || 'showAllExperiences' in config

export const parseFilterConfig = (value: string): ExperiencesFilterConfig => {
  try {
    const parsed = JSON.parse(value)

    if (isLegacyConfig(parsed)) {
      return migrateLegacyConfig(parsed)
    }

    return parsed as ExperiencesFilterConfig
  } catch {
    return DEFAULT_FILTER_CONFIG
  }
}
